// This file shouldn't be touched!
// Be careful what you are doing!
define('core',[
	'module',
	'Modernizr',
	'core/ModernizrExtensions',
	'PEP',
	'jQuery',

	'core/Polyfills',
	'core/RequireJsConfig',
	'core/Page',
	'core/UI',
	'core/helper/EventModule',
	'core/helper/Utilities',
], function (
	rModule,
	Modernizr,
	ModernizrExtensions,
	PointerEvents,
	$,

	Polyfills,
	RequireJsConfig,
	Page,
	UI,
	// We don't need `EventModule` (right now), but it's good to keep it loaded all the time
	EventModule,
	Utilities
) {
	'use strict';

	// Set asynchronous AJAX per default
	$.ajaxSettings.async = true;

	var noCacheEnabled = /no_cache|noCache/.test(RequireJsConfig.urlArgs(rModule.id, rModule.uri));
	UI.enableDebug(noCacheEnabled);
	UI.initModules(document, function() {
		// Trigger the initial resize and scroll events
		setTimeout(function() {
			Page.trigger('resize');
			Page.trigger('scroll');
		}, 500);
	});

	// Picture element polyfill
	if (! Modernizr.picture) {
		require(['3rdparty/picturefill']);
	}
	// // Placeholder polyfill
	// if (! Modernizr.placeholder) {
	// 	require(['3rdparty/placeholders']);
	// }

	return window;
});


